import React from 'react';
import Container from './Container';
import Text from './Text';
import Logo from './Logo';
import Date from './Date';

export default ({ credit_card }) => (
  <Container>
    <Logo src={`/images/payment-icons/${credit_card.credit_card_type}.png`} />
    <Text>{credit_card.credit_card}</Text>
    <Date>{credit_card.created_at}</Date>
  </Container>
);
